// Constants
export const info_afiliacion = () => {
    return {
        info_afiliacion: {
            id: {
                namepath: ['servicios_registrar', 'afiliacion_servicios', 'afiliado_nomina', 'afiliado_liquidacion', 'afiliacion_nueva', 'servicios_afiliacion', 'informes_afiliaciones', 'afiliado_ficha', 'afiliado_crear', 'afiliacion_pendientes', 'aportes_registrar', 'servicios_aportes', 'aportes_cuentas', 'archivo_retiros', 'admin_centros', 'admin_asesor'],
                type: "number",
                label: "id",
                placeholder: "",
                description: "",
                validate: "",
                datatype: {
                    type: "input",
                    disabled: true,
                    predeterminate: null,
                }
            },
            id_datos_afiliado: {
                type: "text",
                label: "Afiliado",
                placeholder: "",
                namepath: ['afiliacion_servicios', 'afiliado_nomina', 'afiliado_liquidacion', 'afiliacion_nueva', 'servicios_afiliacion', 'informes_afiliaciones', 'afiliado_ficha', 'afiliado_crear', 'afiliacion_pendientes'],
                description: "",
                validate: "",
                datatype: {
                    type: "select",
                    disabled: false,
                    predeterminate: "",
                    list: "datos_afiliado",
                    label: 'name'
                }
            },
            id_datos_razon: {
                type: "text",
                label: "Razon Social",
                placeholder: "",
                namepath: ['servicios_registrar', 'afiliacion_servicios', 'afiliado_nomina', 'afiliado_liquidacion', 'afiliacion_nueva', 'servicios_afiliacion', 'informes_afiliaciones', 'afiliado_ficha', 'afiliado_crear', 'afiliacion_pendientes', 'afiliacion_informes', 'aportes_registrar', 'servicios_aportes', 'aportes_cuentas', 'archivo_retiros'],
                description: "",
                validate: "required",
                datatype: {
                    type: "select",
                    disabled: false,
                    predeterminate: 2,
                    list: "datos_razon",
                    label: 'name'
                }
            },
            id_datos_contacto: {
                type: "text",
                label: "Centro de trabajo",
                placeholder: "",
                namepath: ['servicios_registrar', 'afiliacion_servicios', 'afiliado_nomina', 'afiliado_liquidacion', 'afiliacion_nueva', 'servicios_afiliacion', 'informes_afiliaciones', 'afiliado_ficha', 'afiliado_crear', 'afiliacion_pendientes', 'aportes_registrar', 'servicios_aportes', 'aportes_cuentas', 'archivo_retiros', 'admin_centros'],
                description: "",
                validate: "",
                datatype: {
                    type: "select",
                    disabled: false,
                    predeterminate: 1,
                    list: "datos_contacto",
                    label: 'name'
                }
            },
            id_datos_asesor: {
                type: "text",
                label: "Asesor",
                placeholder: "",
                namepath: ['servicios_registrar', 'afiliacion_servicios', 'afiliado_nomina', 'afiliado_liquidacion', 'afiliacion_nueva', 'servicios_afiliacion', 'informes_afiliaciones', 'afiliado_ficha', 'afiliado_crear', 'afiliacion_pendientes', 'aportes_registrar', 'servicios_aportes', 'aportes_cuentas', 'archivo_retiros', 'admin_asesor'],
                description: "",
                validate: "",
                datatype: {
                    type: "select",
                    disabled: false,
                    predeterminate: 1,
                    list: "datos_asesor",
                    label: 'name'
                }
            },
            id_list_tipo: {
                type: "text",
                label: "Tipo Cotizante",
                placeholder: "",
                namepath: ['afiliacion_servicios', 'afiliado_nomina', 'afiliado_liquidacion', 'afiliacion_nueva', 'servicios_afiliacion', 'informes_afiliaciones', 'afiliado_ficha', 'afiliado_crear', 'afiliacion_pendientes', 'aportes_registrar', 'servicios_aportes', 'aportes_cuentas', 'archivo_retiros'],
                description: "",
                validate: "",
                datatype: {
                    type: "select",
                    disabled: false,
                    predeterminate: 3,
                    list: "list_tipo",
                    label: 'name',
                }
            },
            id_list_subtipo: {
                type: "text",
                label: "Subtipo Cotizante",
                placeholder: "",
                namepath: ['afiliacion_servicios', 'afiliado_nomina', 'afiliado_liquidacion', 'afiliacion_nueva', 'servicios_afiliacion', 'informes_afiliaciones', 'afiliado_ficha', 'afiliado_crear', 'afiliacion_pendientes', 'aportes_registrar', 'servicios_aportes', 'aportes_cuentas', 'archivo_retiros'],
                description: "",
                validate: "required",
                datatype: {
                    type: "select",
                    disabled: false,
                    predeterminate: 1,
                    list: "list_subtipo",
                    label: 'name',
                }
            },
            id_list_novedad: {
                type: "text",
                label: "Novedad",
                placeholder: "",
                namepath: ['afiliacion_servicios', 'afiliado_nomina', 'afiliado_liquidacion', 'afiliacion_nueva', 'servicios_afiliacion', 'informes_afiliaciones', 'afiliado_ficha', 'afiliado_crear', 'afiliacion_pendientes', 'aportes_registrar', 'servicios_aportes', 'aportes_cuentas', 'archivo_retiros'],
                description: "",
                validate: "required",
                datatype: {
                    type: "select",
                    disabled: false,
                    predeterminate: 1,
                    list: "list_novedad",
                    label: 'name',
                }
            },
            id_list_users: {
                type: "text",
                label: "Subtipo Cotizante",
                placeholder: "",
                namepath: ['afiliacion_nueva', 'servicios_afiliacion', 'afiliado_ficha', 'afiliado_crear'],
                description: "",
                validate: "required",
                datatype: {
                    type: "select",
                    disabled: false,
                    predeterminate: '',
                    list: "list_users",
                    label: 'name',
                }
            },
            cargo: {
                type: "text",
                label: "Cargo",
                placeholder: "",
                namepath: ['afiliacion_servicios', 'afiliado_nomina', 'afiliado_liquidacion', 'afiliacion_nueva', 'servicios_afiliacion', 'informes_afiliaciones', 'afiliado_ficha', 'afiliado_crear', 'afiliacion_pendientes'],
                description: "",
                validate: "required",
                datatype: {
                    type: "input",
                    disabled: false,
                    predeterminate: "",
                }
            },
            observacion: {
                type: "text",
                label: "Observaciones",
                placeholder: "",
                namepath: ['afiliacion_servicios', 'afiliado_nomina', 'afiliado_liquidacion', 'afiliacion_nueva', 'servicios_afiliacion', 'informes_afiliaciones', 'afiliado_ficha', 'afiliado_crear', 'afiliacion_pendientes'],
                description: "",
                validate: "",
                datatype: {
                    type: "input",
                    disabled: false,
                    predeterminate: "",
                }
            },
            fecha: {
                type: "number",
                label: "fecha",
                placeholder: "",
                namepath: ['afiliacion_servicios', 'afiliado_nomina', 'afiliado_liquidacion', 'afiliacion_nueva', 'servicios_afiliacion', 'informes_afiliaciones', 'afiliado_ficha', 'afiliado_crear', 'afiliacion_pendientes'],
                description: "",
                validate: "",
                datatype: {
                    type: "date",
                    disabled: false,
                    predeterminate: "",
                }
            },
            exonerado: {
                type: "boolean",
                label: "Exonerado Parafiscales",
                placeholder: "",
                namepath: ['afiliacion_servicios', 'afiliado_nomina', 'afiliado_liquidacion', 'afiliacion_nueva', 'servicios_afiliacion', 'informes_afiliaciones', 'afiliado_ficha', 'afiliado_crear', 'afiliacion_pendientes', 'aportes_registrar', 'servicios_aportes', 'aportes_cuentas', 'archivo_retiros'],
                description: "",
                validate: "",
                datatype: {
                    type: "check",
                    disabled: false,
                    predeterminate: 1,
                }
            },
            exterior: {
                type: "text",
                label: "Exterior",
                placeholder: "",
                namepath: [''],
                description: "",
                validate: "",
                datatype: {
                    type: "input",
                    disabled: false,
                    predeterminate: "",
                }
            },
            dias: {
                namepath: ['afiliacion_servicios', 'afiliado_nomina', 'afiliado_liquidacion', 'afiliacion_nueva', 'servicios_afiliacion', 'informes_afiliaciones', 'afiliado_ficha', 'afiliado_crear', 'afiliacion_pendientes', 'facturacion_facturas', 'aportes_registrar', 'servicios_aportes', 'aportes_cuentas', 'archivo_retiros'],
                type: 'number',
                label: 'Días Aporte',
                placeholder: '',
                description: 'Dias Aporte',
                validate: 'required',
                datatype: {
                    type: 'price',
                    disabled: true,
                    predeterminate: 30,
                    prepend: '',
                    append: '',
                }
            },
            salario: {
                namepath: ['afiliacion_servicios', 'afiliado_nomina', 'afiliado_liquidacion', 'afiliacion_nueva', 'servicios_afiliacion', 'informes_afiliaciones', 'afiliado_ficha', 'afiliado_crear', 'afiliacion_pendientes', 'facturacion_facturas', 'aportes_registrar', 'servicios_aportes', 'aportes_cuentas', 'archivo_retiros'],
                type: 'number',
                label: 'Salario',
                placeholder: '',
                description: 'Salario',
                validate: '',
                datatype: {
                    type: 'price',
                    disabled: false,
                    predeterminate: 1160000,
                    prepend: '$',
                    append: '',
                }
            },
            salariobase: {
                namepath: ['afiliacion_servicios', 'afiliado_nomina', 'afiliado_liquidacion', 'afiliacion_nueva', 'servicios_afiliacion', 'informes_afiliaciones', 'afiliado_ficha', 'afiliado_crear', 'afiliacion_pendientes', 'facturacion_facturas', 'aportes_registrar', 'servicios_aportes', 'aportes_cuentas', 'archivo_retiros'],
                type: 'number',
                label: 'Salario',
                placeholder: '',
                description: 'Salario',
                validate: '',
                datatype: {
                    type: 'price',
                    disabled: false,
                    predeterminate: 1160000,
                    prepend: '$',
                    append: '',
                }
            },
            ingreso: {
                type: "number",
                label: "Inicio labores",
                placeholder: "",
                namepath: ['afiliacion_servicios', 'afiliado_nomina', 'afiliado_liquidacion', 'afiliacion_nueva', 'servicios_afiliacion', 'informes_afiliaciones', 'afiliado_ficha', 'afiliado_crear', 'afiliacion_pendientes', 'aportes_registrar', 'servicios_aportes', 'aportes_cuentas', 'archivo_retiros'],
                description: "",
                validate: "required",
                datatype: {
                    type: "date",
                    disabled: false,
                    predeterminate: "",
                }
            },
            retiro: {
                type: "number",
                label: "Fecha Retiro",
                placeholder: "",
                namepath: ['afiliacion_servicios', 'afiliado_nomina', 'afiliado_liquidacion', 'afiliacion_nueva', 'servicios_afiliacion', 'informes_afiliaciones', 'afiliado_ficha', 'afiliado_crear', 'afiliacion_pendientes', 'aportes_registrar', 'servicios_aportes', 'aportes_cuentas', 'archivo_retiros'],
                description: "",
                validate: "required",
                datatype: {
                    type: "date",
                    disabled: false,
                    predeterminate: "",
                }
            },
            ano_periodo: {
                type: "text",
                label: "Año aporte",
                placeholder: "",
                namepath: ['afiliacion_servicios', 'afiliado_nomina', 'afiliado_liquidacion', 'afiliacion_nueva', 'servicios_afiliacion', 'informes_afiliaciones', 'afiliado_ficha', 'afiliado_crear', 'afiliacion_pendientes', 'aportes_registrar', 'servicios_aportes', 'aportes_cuentas', 'archivo_retiros'],
                description: "",
                validate: "required",
                datatype: {
                    type: "select",
                    disabled: false,
                    predeterminate: 2023,
                    list: "list_ano",
                    label: 'name'
                }
            },
            mes_periodo: {
                type: "text",
                label: "Mes aporte",
                placeholder: "",
                namepath: ['afiliacion_servicios', 'afiliado_nomina', 'afiliado_liquidacion', 'afiliacion_nueva', 'servicios_afiliacion', 'informes_afiliaciones', 'afiliado_ficha', 'afiliado_crear', 'afiliacion_pendientes', 'aportes_registrar', 'servicios_aportes', 'aportes_cuentas', 'archivo_retiros'],
                description: "",
                validate: "required",
                datatype: {
                    type: "select",
                    disabled: false,
                    predeterminate: 1,
                    list: "list_mes",
                    label: 'name'
                }
            },
            servicios: {
                type: "boolean",
                label: "Solo servicios",
                placeholder: "",
                namepath: ['servicios_afiliacion'],
                description: "",
                validate: "",
                datatype: {
                    type: "check",
                    disabled: false,
                    predeterminate: 0,
                }
            },
            nota_delete: {
                type: "text",
                label: "Nota",
                placeholder: "",
                namepath: ['informes_afiliaciones'],
                description: "",
                validate: "required",
                datatype: {
                    type: "input",
                    disabled: false,
                    predeterminate: null
                }
            },
            prioridad: {
                type: "boolean",
                label: "Prioridad",
                placeholder: "",
                namepath: ['afiliado_ficha'],
                description: "",
                validate: "",
                datatype: {
                    type: "check",
                    disabled: false,
                    predeterminate: 0,
                }
            },
        }
    }
}